import { useState, useCallback } from 'react';

function useUserLocation() {
    const [userLocation, setUserLocation] = useState(null);
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [locationError, setLocationError] = useState(null);
  
    const getUserLocation = useCallback(() => {
      if (!('geolocation' in navigator)) {
        setLocationError('Geolokalizacja nie jest dostępna w twojej przeglądarce');
        return;
      }
  
      setIsLoadingLocation(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
          setIsLoadingLocation(false);
        },
        (error) => {
          setLocationError(error.message);
          setIsLoadingLocation(false);
        }
      );
    }, []);



  
    return {
      userLocation,
      isLoadingLocation,
      locationError,
      getUserLocation
    };
    
  }
  
  export default useUserLocation;